/**
 * feat-354-auto-copy-lessons — lucide's `Copy` icon (v0.474 geometry, verbatim),
 * inlined for the tree Copy chip.
 *
 * Why not `import { Copy } from 'lucide-react'`: `MasterDetailTree.tsx` has never
 * imported lucide, and lucide is ESM that CRA's jest preset does not transform, so
 * the import would break every existing tree test suite that does not mock lucide
 * (feat-187, unitSwatch). Same pixels, no new test coupling (spec AC6).
 */
import React from 'react';

export const CopyGlyph: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    focusable="false"
    data-icon="Copy"
  >
    <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
  </svg>
);
